import { initializeTelemetry } from '@nerdswhofish/browser-telemetry';

window.appTelemetry = initializeTelemetry({
  url: 'https://faro-collector-prod-us-east-3.grafana.net/collect/7fac2c08ed85eeb0b942f147d2510d66',
  app: { name: 'Toad Memories', version: __APP_VERSION__, environment: 'production' },
  routes: ["/","/api/checkout","/api/tiller-webhook"],
  assets: ["/telemetry.js","/script.js"],
  operations: ["checkout"],
});
